<template>
    <div>
        <NavComponent :index="2"></NavComponent>
        <SideBarComponent></SideBarComponent>
        <div class="procedure">
            <div class="banner" v-lazy:backgroundImage = banner_img>

            </div>
            <div class="content-container main" v-bind:style="{backgroundImage:'url('+ line_img+')'}">
                <div class="pro-item">
                    <img class="pro-img1" v-lazy="pro_img1" />
                    <div class="item-right">
                        <h3><span>1.</span>选择意向房源</h3>
                        <p>在网站首页搜索框输入城市或者房源名称进行搜索，网站对每个房源都有非常详尽的阐述，您可根据自己的需求，如地段、价位等进行比较，挑选自己喜欢的房源。</p>
                        <p>如有问题可随时通过我们的订房微信号向客服人员咨询，若您已在英国本地，可由当地客服人员安排实地看房。</p>
                    </div>
                </div>
                <div class="pro-item">
                    <div class="item-right">
                        <h3><span>2.</span>确认预定，提交个人资料信息</h3>
                        <p>我们的客服人员会充分了解您的预定需求，为您详细介绍房源情况，在您最终确定意向房源后，需要提供护照等个人资料信息。</p>
                    </div>
                    <img class="pro-img2" v-lazy="pro_img4" />
                </div>
                <div class="pro-item">
                    <img class="pro-img3" v-lazy="pro_img3" />
                    <div class="item-right">
                        <h3><span>3.</span>签合同、付租金</h3>
                        <p>与我们签订统一正式的租房合同，并支付租金。请仔细阅读，明确租房条款，如有疑问或需要接送机等其他附加服务，也可提前与我们沟通，以便于帮您协调安排。</p>
                    </div>
                </div>
                <div class="pro-item">
                    <div class="item-right">
                        <h3><span>4.</span>办理入住</h3>
                        <p>请保存好租房合同，入住时出示您的租房合同和相关个人证件，即可办理入住。如有任何问题，可随时联系我们，我们乐于为您提供一切帮助。</p>
                    </div>
                    <img class="pro-img4" v-lazy="pro_img2" />
                </div>
            </div>
        </div>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'

import banner_img from '@assets/image/procedure/procedure-banner.jpg'
import line_img from '@assets/image/procedure/line-bg.png'
import pro_img1 from '@assets/image/procedure/pro-img1.png'
import pro_img2 from '@assets/image/procedure/pro-img2.png'
import pro_img3 from '@assets/image/procedure/pro-img3.png'
import pro_img4 from '@assets/image/procedure/pro-img4.png'

export default {
    name: 'MoveHousePage',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data(){
        return {
            banner_img,line_img,
            pro_img1,pro_img2,pro_img3,pro_img4

        }
    },
    mounted(){

    },
    methods:{

    }

}
</script>
<style lang="scss" scoped>
.banner{
    width: 100%;
    height: 20.8rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 20.8rem;  
}
.main{
    padding:3rem 0 4.5rem;
    background-position:10rem 27rem;
    background-repeat: no-repeat;
    background-size: 40rem 53rem;
    .pro-item{
        display:flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4rem;
        .pro-img1{
            width: 19.6rem;
            height: 24rem;
        }
        .pro-img2{
            width: 21rem;
            height: 16.5rem;
        }
        .pro-img3{
            width: 25.5rem;
            height: 21.4rem;
        }
        .pro-img4{
            width: 21.5rem;
            height: 20.3rem;
        }
        .item-right{
            width: 30rem;
            span{
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
                margin-right: 1.2rem;
                color: #fff;
                text-align: center;
                font-size: 1.5rem;
                font-weight: 700;
                line-height: 2rem;
                display: inline-block;
                background-color: #52657c;
            }
            h3{
                color: #0e2d57;
                font-size: 1.2rem;
                line-height: 2rem;
                margin-bottom: 1.2rem;
                display: flex;
                align-items: center;
            }
            p{
                font-size: 1rem;
                color: #0e2d57;
                line-height: 2rem;
            }
        }
    }
}
@media only screen and (max-width: 1024px){
    .banner{
        height: 18rem;
        background-size:cover;
    }
    .main{
        padding: 3rem 3% 1rem;
        background: #fff !important;
        .pro-item{
            .pro-img1{
                width: 9.8rem;
                height: 12rem;
            }
            .pro-img2{
                width: 10.5rem;
                height: 8.25rem;
            }
            .pro-img3{
                width: 12.75rem;
                height: 10.7rem;
            }
            .pro-img4{
                width: 10.75rem;
                height: 10.15rem;
            }
            .item-right{
                width: 20rem;
            }
        }
    }

}
</style>